import { useState, useCallback, useEffect } from "react";
import "./StreamView.css";
import { fetchStreamFrame, fetchStreamStatus } from "./api";

interface StreamViewProps {
  onScreenshot: (dataUrl: string) => void;
  onStatusMessage: (msg: string) => void;
}

export default function StreamView({ onScreenshot, onStatusMessage }: StreamViewProps) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      try {
        const status = await fetchStreamStatus();
        if (!cancelled) setActive(status.active);
      } catch {
        if (!cancelled) setActive(false);
      }
    };
    poll();
    const id = setInterval(poll, 2000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  const handleScreenshot = useCallback(async () => {
    try {
      onStatusMessage("Capturing...");
      const dataUrl = await fetchStreamFrame();
      onScreenshot(dataUrl);
      onStatusMessage("Screenshot added");
      setTimeout(() => onStatusMessage(""), 2000);
    } catch {
      onStatusMessage("No stream active");
      setTimeout(() => onStatusMessage(""), 2000);
    }
  }, [onScreenshot, onStatusMessage]);

  return (
    <div className="stream-view-container">
      <div className="stream-controls">
        <div className="stream-status-row">
          <span className={`stream-status-pill ${active ? "active" : "inactive"}`}>
            {active ? "● Live" : "○ Waiting for stream"}
          </span>
        </div>
        <button className="screenshot-btn" onClick={handleScreenshot}>
          Screenshot
        </button>
      </div>
      <div className="stream-display">
        <img src="/api/stream" alt="Stream" />
        {!active && <div className="stream-overlay">Waiting for screen-share…</div>}
      </div>
    </div>
  );
}
